import AccountBrandList from './components/AccountBrandList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import { connect } from 'react-redux';

import { updateBrand } from '../../shared/redux/entities/actions'

import { getBrandsWithKPIs } from '../../shared/redux/selectors'

function mapStateToProps(state,props){
  const brands = getBrandsWithKPIs(state).filter((b) => b.agencyId === props.accountId)

  return {
    brands:brands
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ updateBrand },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountBrandList));



// WEBPACK FOOTER //
// ./src/routes/AccountBrandList/index.js